import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Notice, PageHeader } from "@/components/common/States";
import { useSchoolCan, useSpaceName } from "@/context/AuthContext";
import { ReadOnlyBanner } from "../SchoolHome";
import { SubjectsTab, YearsTab } from "./YearsSubjects";
import { ClassesTab } from "./ClassesTab";
import { AssignmentsTab, GuardiansTab } from "./AssignGuardians";
import { ScheduleTab } from "./ScheduleTab";

export default function AcademicPage() {
  const space = useSpaceName();
  const canManage = useSchoolCan("academic:manage");
  const canGuardians = useSchoolCan("guardians:manage");
  const canRead = useSchoolCan("academic:read");
  if (!canRead) {
    return <div className="space-y-6"><PageHeader eyebrow={space} title="Data Akademik" /><Notice tone="danger" testId="academic-denied">Akses ditolak. Peran Anda tidak memiliki izin untuk halaman ini.</Notice></div>;
  }
  const tabs = [
    ["tahun", "Tahun Ajaran", <YearsTab canManage={canManage} />],
    ["kelas", "Kelas/Rombel", <ClassesTab canManage={canManage} />],
    ["mapel", "Mata Pelajaran", <SubjectsTab canManage={canManage} />],
    ["penugasan", "Penugasan Guru", <AssignmentsTab canManage={canManage} />],
    ["jadwal", "Jadwal Pelajaran", <ScheduleTab canManage={canManage} />],
    ...(canGuardians ? [["wali", "Relasi Orang Tua", <GuardiansTab />]] : []),
  ];
  return (
    <div className="space-y-6">
      <PageHeader eyebrow={space} title="Data Akademik" description="Tahun ajaran, kelas, mata pelajaran, penugasan guru, dan relasi orang tua/wali. Semua data hanya berlaku di sekolah ini." />
      <ReadOnlyBanner />
      <Tabs defaultValue="tahun">
        <TabsList className="flex-wrap h-auto">
          {tabs.map(([k, label]) => <TabsTrigger key={k} value={k} data-testid={`academic-tab-${k}`}>{label}</TabsTrigger>)}
        </TabsList>
        {tabs.map(([k, , el]) => <TabsContent key={k} value={k} className="mt-6">{el}</TabsContent>)}
      </Tabs>
    </div>
  );
}
